var map = {
	"./0.png": 857,
	"./1.png": 3952,
	"./10.png": 1794,
	"./11.png": 6619,
	"./12.png": 4640,
	"./2.png": 7451,
	"./3.png": 6322,
	"./4.png": 2669,
	"./5.png": 1540,
	"./6.png": 447,
	"./7.png": 7782,
	"./8.png": 7585,
	"./9.png": 2968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1550;